import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Contactpage from "../../components/Contactpage/Contactpage";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t("contactpage.title")} pagesub={t("contact")} />
      <Contactpage />
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default ContactPage;
